/* Storefront UI only. Zakeke's app owns design creation, pricing and cart writes. */
(() => {
  'use strict';
  const initialize = (root = document) => {
    root.querySelectorAll('[data-zmw-customizable="true"]').forEach(form => {
      if (form.dataset.zmwInitialized) return;
      form.dataset.zmwInitialized = 'true';
      // Keep Enter and a slow/failed app load from ordering an undecorated blank.
      form.addEventListener('submit', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const designer = form.querySelector('#zakeke-product-button, #zakeke-configurator');
        if (designer) designer.focus();
        const status = form.querySelector('[data-zmw-designer-status]');
        if (status) status.textContent = designer ? 'Use the Customize button to review your design before adding it to your cart.' : 'The designer is still loading. Please refresh the page or contact us if it does not appear.';
      }, true);
      const update = () => {
        const button = form.querySelector('#zakeke-product-button, #zakeke-configurator');
        const status = form.querySelector('[data-zmw-designer-status]');
        if (!button) return;
        form.dataset.zmwDesignerReady = 'true';
        button.classList.add('zmw-designer-button');
        // Zakeke appends its own container after load. Move that same container
        // ahead of the guide; its native listeners and form membership stay intact.
        const guide = form.querySelector('.zmw-designer-guide');
        const container = button.closest('.zakeke-product-button-container');
        if (guide && container && container.parentElement === form && guide.parentElement === form && container.nextElementSibling !== guide) {
          form.insertBefore(container, guide);
        }
        // Change the native app button's label without replacing it or its listeners.
        if (!button.children.length && /^(customize(?: and add to cart)?|customize and order)$/i.test(button.textContent.trim())) {
          if (button.textContent !== 'Customize and Order') button.textContent = 'Customize and Order';
        }
        if (status && status.textContent !== 'Your design opens in our interactive customizer.') status.textContent = 'Your design opens in our interactive customizer.';
      };
      new MutationObserver(update).observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:['id']});
      update();
      setTimeout(() => {
        if (form.dataset.zmwDesignerReady) return;
        const status = form.querySelector('[data-zmw-designer-status]');
        if (status) status.textContent = 'The designer has not loaded. Refresh the page or contact us for help.';
      }, 12000);
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  // Native details elements provide keyboard-accessible FAQs without a JS dependency.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-zmw-preview]');
    if (!button) return;
    const image = button.querySelector('img');
    if (!image) return;
    let dialog = document.getElementById('zmw-preview-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'zmw-preview-dialog';
      dialog.className = 'zmw-preview-dialog';
      const close = document.createElement('button');
      close.type = 'button'; close.textContent = 'Close preview ×';
      close.addEventListener('click', () => dialog.close());
      const preview = document.createElement('img');
      dialog.append(close, preview); document.body.append(dialog);
      dialog.addEventListener('click', e => {if (e.target === dialog) dialog.close();});
    }
    const preview = dialog.querySelector('img');
    preview.src = image.src; preview.alt = image.alt;
    dialog.showModal();
  });
})();
